export default {
  //截取URL
  getUrlPar(variable) {
    const query = window.location.href;
    const interlinkage = query.replace(/\.html/g, "");
    const vars = interlinkage.split("&");
    for (let i = 1; i < vars.length; i++) {
      let pair = vars[i].split("/");
      if (pair[0] == variable) {
        return pair[1];
      }
    }
    return false;
  },

  // 跳转对应锚点
  scrollToAnchor(anchorName) {
    if (anchorName) {
      // 找到锚点
      let anchorElement = document.getElementById(anchorName);
      // 如果对应id的锚点存在，就跳转到锚点
      if (anchorElement) {
        anchorElement.scrollIntoView();
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/js/public.js